/*
    1) Pollyfills
        -- Number.isInteger
        -- Object.values
        -- Array.prototype.find
        -- String.prototype.startsWith
        -- String.prototype.endsWith

    2) Overrides
        * Date.prototype.toJSON

    2) Custom Extensions
        * String.prototype.format
        * Array.prototype.selectMany
        * Date.prototype.addDays
        * Date.prototype.toLocalISOString
        * Date.prototype.toDurationString
*/
(function () {
    'use strict';

    // Pollyfills
    if (!Number.isInteger) {
        Number.isInteger = function (value) {
            return typeof value === "number" &&
              isFinite(value) &&
              Math.floor(value) === value;
        };
    }

    if (!Object.values) {
        Object.values = (function () {
            var
                hasOwnProperty = Object.prototype.hasOwnProperty,
                hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
                dontEnums = ['toString', 'toLocaleString', 'valueOf', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'constructor'],
                dontEnumsLength = dontEnums.length;

            return function (obj) {
                if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
                    throw new TypeError('Object.values called on non-object');
                }

                var result = [], prop, i;

                for (prop in obj) {
                    if (hasOwnProperty.call(obj, prop)) {
                        result.push(obj[prop]);
                    }
                }

                if (hasDontEnumBug) {
                    for (i = 0; i < dontEnumsLength; i++) {
                        if (hasOwnProperty.call(obj, dontEnums[i])) {
                            result.push(obj[dontEnums[i]]);
                        }
                    }
                }
                return result;
            };
        }());
    }

    if (!Array.prototype.find) {
        Array.prototype.find = function (predicate) {
            'use strict';
            if (this == null) {
                throw new TypeError('Array.prototype.find called on null or undefined');
            }
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            var list = Object(this);
            var length = list.length >>> 0;
            var thisArg = arguments[1];
            var value;

            for (var i = 0; i < length; i++) {
                value = list[i];
                if (predicate.call(thisArg, value, i, list)) {
                    return value;
                }
            }
            return undefined;
        };
    }

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
            position = position || 0;
            return this.substr(position, searchString.length) === searchString;
        };
    }

    if (!String.prototype.endsWith) {
        String.prototype.endsWith = function (searchString, position) {
            var subjectString = this.toString();
            if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
                position = subjectString.length;
            }
            position -= searchString.length;
            var lastIndex = subjectString.lastIndexOf(searchString, position);
            return lastIndex !== -1 && lastIndex === position;
        };
    }

    // Overrides
    Date.prototype.toJSON = function () {
        return this.toLocalISOString();
    }

    // Extensions
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined' ? args[number] : match;
        });
    };

    Array.prototype.selectMany = function (fn) {
        return this.map(fn).reduce(function (x, y) { return x.concat(y); }, []);
    }

    Date.prototype.addDays = function (days) {
        var result = new Date(this.getTime());
        result.setDate(result.getDate() + days);
        return result;
    };

    Date.prototype.toLocalISOString = function () {
        if (isNaN(this.getTime()))
            return null;
        return new Date(this.getTime() - this.getTimezoneOffset() * 60000).toISOString().substr(0, 23);
    }

    Date.prototype.toDurationString = function () {
        if (isNaN(this.getTime()))
            return null;
        return 'PT' + [this.getHours(), this.getMinutes(), this.getSeconds() + this.getMilliseconds() / 1000].map(function (value, idx) {
            return value && value + "HMS".substr(idx, 1) || '';
        }).join('');
    }
})();